import type { SVGProps } from "react";

export function IconBlueMoneyCash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 37.75V55H57V37.75M7 37.75V49H57V37.75M7 37.75V43H57V37.75"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <mask
        id="mask0_9190_44324"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="8"
        width="52"
        height="30"
      >
        <rect
          x="7"
          y="9"
          width="50"
          height="28"
          fill="#5DD95D"
          stroke="#5DD95D"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_9190_44324)">
        <rect
          x="7"
          y="9"
          width="50"
          height="28"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
        />
        <ellipse
          cx="32"
          cy="23"
          rx="8"
          ry="12"
          stroke="#23232C"
          strokeWidth="1.5"
        />
        <path
          d="M16 38L16 37C16 32.0294 11.9706 28 7 28L6 28"
          stroke="#23232C"
          strokeWidth="1.5"
        />
        <path
          d="M48 8L48 9C48 13.9706 52.0294 18 57 18L58 18"
          stroke="#23232C"
          strokeWidth="1.5"
        />
        <path
          d="M6 18L7 18C11.9706 18 16 13.9706 16 9L16 8"
          stroke="#23232C"
          strokeWidth="1.5"
        />
        <path
          d="M58 28L57 28C52.0294 28 48 32.0294 48 37L48 38"
          stroke="#23232C"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
